// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__371wk","wrapper":"styles_wrapper__rYPae","content":"styles_content__1vRA7","description":"styles_description__1Ymtk"};